export default __webpack_public_path__ + "static/media/serverError.d69473e1.svg";